export function createUrlSearchParams<T extends Record<string, any>>(params: T): URLSearchParams {
  const urlSearchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      urlSearchParams.set(key, value.toString());
    }
  });
  return urlSearchParams;
}

/**
 * Retrieves the current request URL from headers
 * Falls back to environment variables or a default path
 */
export function getCurrentRequestUrl(headersList: { get(name: string): string | null }): string {
  return headersList.get('x-url') || process.env.NEXT_PUBLIC_BASE_URL || '/';
}

/**
 * Generates a full profile URL with locale support
 * Uses window.location.origin on client side to construct the full URL
 * @param userId - The user's ID
 * @param locale - The locale (e.g., 'en', 'fr')
 * @returns Full URL to the professional profile page
 * @example getProfileUrl('123', 'en') => 'http://localhost:3000/en/professional/123'
 */
export function getProfileUrl(userId: string, locale: string): string {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/${locale}/professional/${userId}`;
  }

  return `/${locale}/professional/${userId}`;
}
